import { render, staticRenderFns } from "./InventoryListFilters.vue?vue&type=template&id=2ca7831d&"
import script from "./InventoryListFilters.vue?vue&type=script&lang=js&"
export * from "./InventoryListFilters.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports